import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import UserProfileSvg from "../../../../../../../media/images/icons/user-profile";

export default function ApproveInfo() {
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <UserProfileSvg size={22} color={theme.palette.secondary.main} />

        <Typography
          sx={{
            textAlign: "center",
            fontSize: "16px",
            fontWeight: "600",
            color: "secondary.main",
          }}
          variant="h3"
        >
          مشخصات شرکت:{" "}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: "600",
          color: "primary.main",
          marginTop: "16px",
        }}
        variant="h3"
      >
        {"شرکت پویش سازان جنوب نوآور "}
      </Typography>

      <ul
        style={{
          margin: "16px 0px",
          padding: 0,
          color: theme.palette.primary.main,
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <li
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography>کدسازمانی: 123456789112</Typography>
          <Typography>کدپستی: 1234567891</Typography>
        </li>
        <li
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography>شناسه ملی: 12345678912</Typography>
          <Typography>کهگیلویه و بویراحمد</Typography>
        </li>
        <li
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography>تلفن: {"021-65625849"}</Typography>
          <Typography>{"سیستان و بلوچستان"}</Typography>
        </li>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "600",
            color: "primary.main",
            marginTop: "16px",
          }}
          variant="h3"
        >
          {"آدرس:شهرک غرب،خیابان فلان، انتهای بلوار، کوچه 52 ، پلاک 12"}
        </Typography>
        <hr
          style={{
            border: "1px dashed gray",
          }}
        />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <UserProfileSvg size={22} color={theme.palette.secondary.main} />

          <Typography
            sx={{
              textAlign: "center",
              fontSize: "16px",
              fontWeight: "600",
              color: "secondary.main",
            }}
            variant="h3"
          >
            مشخصات شرکت:{" "}
          </Typography>
        </Box>
        <li
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography>{"رضار ضازاده فلانی زادگان"}</Typography>
          <Typography>{"کدملی:0123456789"}</Typography>
        </li>
        <Typography
          sx={{
            textAlign: "center",
            fontSize: "16px",
            fontWeight: "600",
            color: "primary.main",
          }}
          variant="h3"
        >
          {"شماره تلفن همراه: 09555555555"}
        </Typography>
      </ul>
    </>
  );
}
